//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  computed,
} from "@angular/core";

//local imports
import { Messenger } from "@shared/data/messaging/messenger";
import { PresenterType } from "@shared/components/presenter/presenter-type";
import { UserLoggedOutMessage } from "@core/messages";
import { AppStateService } from "@core/data/services";
import { ClosePlatformDialogMessage } from "@app/components/notification/messages";
import { UserDialogModel } from "@app/components/layout";

@PresenterType({
  model: UserDialogModel,
})
@Component({
  selector: 'user-dialog',
  standalone: false,
  templateUrl: './user-dialog.component.html',
  styleUrl: './user-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserDialogComponent implements OnDestroy {
  public currentUser = computed(() => this.appStateService.CurrentUser());

  constructor(
    private messenger: Messenger,
    private appStateService: AppStateService) {
  }

  public logout(): void {
    this.messenger.send(new ClosePlatformDialogMessage());
    this.messenger.send(new UserLoggedOutMessage());
  }

  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
  }

}